import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ADMIN_LOGIN_PATH } from "@/lib/adminRoutes";

const isAdmin = (u) => u?.role === "admin" || u?.is_admin;

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();

  if (loading && user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-950">
        <div className="flex flex-col items-center gap-3">
          <div className="w-6 h-6 border-2 border-zinc-700 border-t-emerald-500 rounded-full animate-spin" />
          <span className="text-xs text-zinc-600 uppercase tracking-[0.15em]">Loading</span>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to={ADMIN_LOGIN_PATH} replace />;
  if (!isAdmin(user)) return <Navigate to={ADMIN_LOGIN_PATH} replace />;

  return children;
}
